import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { ContactPerson } from "../meta/ContactPerson.interface"
import { INITIAL_CONTACT_PERSON } from "../meta/initial-contact-person.const"

@Injectable({
  providedIn: "root"
})
export class ContactPersonService {
  private readonly _contactPerson$ = new BehaviorSubject<ContactPerson>(INITIAL_CONTACT_PERSON)
  public readonly contactPerson$ = this._contactPerson$.asObservable()

  public getContactPerson(): ContactPerson {
    return this._contactPerson$.getValue()
  }

  public setContactPerson(contactPerson: Partial<ContactPerson>): void {
    this._contactPerson$.next({
      ...this._contactPerson$.getValue(),
      ...contactPerson
    })
  }

}
